import { render } from "./collegestudent.vue?vue&type=template&id=57b54d56"
import script from "./collegestudent.vue?vue&type=script&lang=js"
export * from "./collegestudent.vue?vue&type=script&lang=js"

import exportComponent from "F:\\desktop2025\\UG_College_administration\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__